import React, { useEffect, useState } from "react";

import { TabMenu } from "primereact/tabmenu";
import { Outlet, useLocation, useParams } from "react-router-dom";
import useProjectContext from "../hooks/useProjectContext";
import ProjectDropDown from "./ProjectDropDown";
import { useHasPermissions } from "../../../../hooks/useHasPermissions";

const Layout = () => {
  const path = useLocation().pathname;
  const {objectId, deviceId} = useParams();
  const [activeIndex, setActiveIndex] = useState(2);
  const { projectId, user } = useProjectContext();

  const isPermitted = useHasPermissions("USE_DATA_SERVICES");

  useEffect(() => {
    switch (path) {
      case `/mdm/${projectId}`:
      case `/mdm/${projectId}/`:
        return setActiveIndex(0);
      case `/mdm/${projectId}/devices`:
        return setActiveIndex(1);
      case `/mdm/${projectId}/analytics`:
        return setActiveIndex(2);
      case `/mdm/${projectId}/jobs`:
        return setActiveIndex(3);
      case `/mdm/${projectId}/settings`:
        return setActiveIndex(4);
      case `/mdm/${projectId}/objects/${objectId}`:
        return setActiveIndex(5);
      case `/mdm/${projectId}/devices/${deviceId}`:
        return setActiveIndex(6);
      default:
        return setActiveIndex(10);
    }
  }, [path]);

  const items = [
    {
      label: "Objects",
      icon: "pi pi-list",
      url: `#/mdm/${projectId}/`,
    },
    {
      label: "Devices",
      icon: "pi pi-list",
      url: `#/mdm/${projectId}/devices`,
    },
    {
      label: "Analytics",
      icon: "pi pi-chart-line",
      url: `#/mdm/${projectId}/analytics`,
    },
    {
      label: "Jobs",
      icon: "pi pi-briefcase",
      url: `#/mdm/${projectId}/jobs`,
    },
    {
      label: "Settings",
      icon: "pi pi-cog",
      url: `#/mdm/${projectId}/settings`,
    },
    {
      label: "Object",
      icon: "pi pi-book",
      url: `#/mdm/${projectId}/objects/${objectId}`,
      visible: !!objectId,
    },
    {
      label: "Device",
      icon: "pi pi-book",
      url: `#/mdm/${projectId}/devices/${deviceId}`,
      visible: !!deviceId,
    },
  ];

  if(!isPermitted) return <div>Missing required permissions to access this feature</div>;

  return (
    <div className="bg-white p-0 sm:p-3">
      <div className="flex gap-1 flex-column-reverse md:flex-row">
        {projectId && (
          <TabMenu
            model={items}
            className="flex-1 justify-content-end"
            activeIndex={activeIndex}
            onTabChange={e => setActiveIndex(e.index)}
          />
        )}
        {user?.companyRef && <ProjectDropDown />}
      </div>
      <Outlet />
    </div>
  );
};

export default Layout;
